var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 33,
    viewBox: "0 0 132 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.603 0L117.912 4.26568L119.527 7.82041L122.354 6.57626L119.661 13.5524L114.95 25.8163L110.598 13.5969H97.4521V24.3499C97.4521 26.2162 96.2855 27.3714 94.7152 27.3714C93.1448 27.3714 91.7988 26.1717 91.7988 24.3499V13.5524H76.9477V24.3055C76.9477 26.1717 75.7811 27.327 74.2107 27.327C72.6404 27.327 71.2943 26.1273 71.2943 24.3055V13.5524H55.9048L51.777 23.3279L47.6492 13.5524H32.3494V24.3055C32.3494 26.1717 31.1829 27.327 29.6125 27.327C28.0421 27.327 26.6961 26.1273 26.6961 24.3055V13.5524H13.6846L10.0054 20.7508L6.19171 13.5524H0L6.86472 26.5716V32.2592H13.1013V26.4383L17.1842 18.6624H20.4595V24.3499C20.4595 29.3266 24.0938 32.5258 29.5676 32.5258C35.0415 32.5258 38.5411 29.3266 38.5411 24.3499V18.6624H41.0986V32.2592H46.5275V22.0393L49.758 30.4374H53.8409L57.0714 22.0393V32.2592H62.5003V18.6624H65.0578V24.3499C65.0578 29.3266 68.692 32.5258 74.1659 32.5258C79.6397 32.5258 83.1394 29.3266 83.1394 24.3499V18.6624H85.4725V24.3499C85.4725 29.3266 89.1067 32.5258 94.5806 32.5258C100.054 32.5258 103.554 29.3266 103.554 24.3499V18.6624H106.201L111.406 32.2592H118.001L125.18 13.5969L127.154 8.44249L128.411 11.1974L132 9.59778L127.603 0Z",
    fill: "#006FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d63b1d1a6d608f9398cdeec02bd7a2b.svg";
export { ForwardRef as ReactComponent };